// extracted by mini-css-extract-plugin
export default {"googleButton":"Login_googleButton__eWVHm","googleIcon":"Login_googleIcon__A7QCX"};